module.exports = __webpack_public_path__ + "static/media/sf_3300.e3b7bd8ea25176323729c811cc629483.png";